import { useHirerAuth } from '@seek/hirer-auth-react';
import {
  Box,
  Heading,
  Stack,
  Columns,
  Column,
  ContentBlock,
  Text,
  Inline,
  IconPromote,
} from 'braid-design-system';
import React from 'react';

import { ButtonLink } from 'src/components';
import { CREATE_JOB, REGISTER } from 'src/shared/links';

import adData from '../../adData';
import Concierge from '../Concierge/Concierge';
import RecruiterNetwork from '../RecruiterNetwork/RecruiterNetwork';

import SellingPoints from './components/SellingPoints/SellingPoints';
import classicAdImg from './images/jobad_classic.svg';
import premiumAdImg from './images/jobad_premium.svg';
import standoutImg from './images/jobad_standout.svg';

import * as styles from './CardLayout.css';

const CardLayout = () => {
  const { authenticated } = useHirerAuth();

  const getImageSrc = (type: string) => {
    const getUrl = (name: string): string =>
      `url('data:image/svg+xml;utf8,${name.replace(/\#/g, '%23')}')`;

    if (type === 'Premium') {
      return getUrl(premiumAdImg);
    }

    if (type === 'StandOut') {
      return getUrl(standoutImg);
    }

    return getUrl(classicAdImg);
  };

  return (
    <ContentBlock>
      <Stack space="medium" align="center">
        <Columns align="center" collapseBelow="desktop" space="medium">
          {adData.map((data, i) => (
            <Column width="1/3" key={i}>
              <Box
                borderRadius="large"
                padding="medium"
                paddingY="large"
                height="full"
                boxShadow="borderNeutralLight"
                marginX={{ mobile: 'medium', desktop: 'none' }}
                width="full"
                className={`${styles.card} ${
                  data.name === 'Premium' && styles.premiumCard
                }`}
                position="relative"
              >
                {data.name === 'Premium' && (
                  <Box background="promote" className={styles.featureBar}>
                    <Inline space="xsmall" alignY="center" align="center">
                      <IconPromote size="small" />
                      <Text>Featured</Text>
                    </Inline>
                  </Box>
                )}
                <Box style={{ height: '654px' }}>
                  <Stack space="large">
                    <Box
                      width="full"
                      className={styles.image}
                      style={{
                        backgroundImage: getImageSrc(data.name),
                      }}
                    />
                    <Heading level="2" weight="weak" align="center">
                      {data.name}
                    </Heading>
                    <Box paddingX="gutter">
                      <Text size="large" tone="secondary" align="center">
                        {data.tagline}
                      </Text>
                    </Box>
                    <ButtonLink
                      href={authenticated ? CREATE_JOB : REGISTER}
                      type="button"
                      tracking="post-job-button-clicked"
                    >
                      Choose {data.name}
                    </ButtonLink>
                    <SellingPoints ad={i} />
                  </Stack>
                </Box>
              </Box>
            </Column>
          ))}
        </Columns>
        <RecruiterNetwork />
        <Concierge />
      </Stack>
    </ContentBlock>
  );
};

export default CardLayout;
